'use client';

import { PropsWithChildren, Suspense } from 'react';
import { ThemeProvider } from 'styled-components';
import { SWRConfig } from 'swr/_internal';

import { NavigationEvents } from '@/components/internal/NavigationEvents';
import { Preloader } from '@/components/Preloader/Preloader';
import { useGAConfigHook } from '@/modules/googleAnalytics';
import theme from '@/theme';

import { GlobalStyles } from '@/styles/GlobalStyles';

export default function Template({ children }: PropsWithChildren) {
  useGAConfigHook();
  return (
    <SWRConfig>
      <ThemeProvider theme={theme}>
        <GlobalStyles theme={theme} />
        <Suspense fallback={<Preloader />}>
          <NavigationEvents />
          {children}
        </Suspense>
      </ThemeProvider>
    </SWRConfig>
  );
}
